import {
    CLIENT_COUNTERS_LOAD_REQUEST,
    CLIENT_COUNTERS_LOAD_SUCCESS,
    CLIENT_COUNTERS_LOAD_ERROR,
} from '../actions/client_counters'

export const initialState = {
    items: {},
    errorMessage: null,
    isLoading: false,
    isLoaded: false,
}

// eslint-disable-next-line complexity
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLIENT_COUNTERS_LOAD_REQUEST: {
        return {
            ...state,
            isLoading: true,
            isLoaded: false,
            errorMessage: null,
        }
    }
    case CLIENT_COUNTERS_LOAD_SUCCESS: {
        return {
            ...state,
            isLoading: false,
            isLoaded: true,
            items: action.payload,
        }
    }
    case CLIENT_COUNTERS_LOAD_ERROR: {
        return {
            ...state,
            isLoading: false,
            isLoaded: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/client_counters.js